document.querySelectorAll('.kk [data-wizard]').forEach(form => {
  const steps = [...form.querySelectorAll('[data-step]')];
  const previous = form.querySelector('[data-prev]');
  const next = form.querySelector('[data-next]');
  const finish = form.querySelector('[data-finish]');
  let index = 0;
  function show() {
    steps.forEach((step, i) => { step.hidden = i !== index; });
    previous.hidden = index === 0;
    next.hidden = index === steps.length - 1;
    finish.hidden = index !== steps.length - 1;
    form.querySelector('[data-step-count]').textContent = `${index + 1} / ${steps.length}`;
    form.querySelector('.kk-step-progress i').style.width = `${(index + 1) / steps.length * 100}%`;
  }
  function validate() {
    for (const input of steps[index].querySelectorAll('input,select,textarea')) {
      if (!input.checkValidity()) { input.reportValidity(); return false; }
    }
    return true;
  }
  next.addEventListener('click', () => { if (validate()) { index++; show(); steps[index].querySelector('input,select,textarea')?.focus(); } });
  previous.addEventListener('click', () => { index--; show(); });
  form.addEventListener('invalid', e => { const i = steps.findIndex(step => step.contains(e.target)); if (i >= 0 && i !== index) { index = i; show(); } }, true);
  const profile = form.querySelector('[name=profile_id]');
  const prefill = () => {
    const selected = profile?.selectedOptions[0];
    if (!selected) return;
    for (const [field, attr] of [['city','city'],['address','address'],['venue','name']]) {
      const input = form.querySelector(`[name=${field}]`);
      if (input && !input.value) input.value = selected.dataset[attr] || '';
    }
  };
  profile?.addEventListener('change', prefill);
  prefill(); show();
});
document.querySelectorAll('.kk [data-near-me]').forEach(button => {
  button.addEventListener('click', () => {
    if (!navigator.geolocation) return alert(button.dataset.error);
    button.disabled = true;
    navigator.geolocation.getCurrentPosition(position => {
      const form = button.closest('form');
      form.elements.lat.value = position.coords.latitude;
      form.elements.lng.value = position.coords.longitude;
      if (form.elements.city) form.elements.city.value = '';
      button.disabled = false;
      form.requestSubmit();
    }, () => { button.disabled = false; alert(button.dataset.error); }, {timeout:15000});
  });
});

// Image sectors can be unequal. Their measured midpoint runs clockwise from
// twelve o'clock; old cached SVGs still fall back to equally spaced sectors.
function calendarWheelAngle(sector, count) {
  const raw = sector.dataset.wheelAngle;
  const angle = typeof raw === 'string' && raw.trim() !== '' ? Number(raw) : NaN;
  return Number.isFinite(angle) ? ((angle % 360) + 360) % 360 : (Number(sector.dataset.wheelIndex) + .5) * 360 / count;
}

function calendarWheelDestination(rotation, angle, turns = 0) {
  const desired = ((360 - angle) % 360 + 360) % 360;
  const current = ((rotation % 360) + 360) % 360;
  const delta = (desired - current + 360) % 360;
  // Measured fractional angles must not turn a rounding error at zero into an
  // unwanted extra revolution when the same category is selected again.
  return rotation + turns * 360 + (Math.min(delta,360-delta) < 1e-7 ? 0 : delta);
}

function calendarFilterParameters(search) {
  const allowed = ['q','city','month','from','to','type','art_form','lat','lng','radius','page','discovery_seed'];
  const values = new URLSearchParams(search);
  // Searchanise treats input[name=q] as a product search. The public calendar URL
  // retains q, but the actual form deliberately uses a different control name.
  if (values.has('calendar_query')) { values.set('q', values.get('calendar_query')); values.delete('calendar_query'); }
  for (const key of [...values.keys()]) {
    if (!allowed.includes(key) || !values.get(key)?.trim()) values.delete(key);
    else values.set(key, values.get(key).trim());
  }
  if (!values.get('lat') || !values.get('lng')) for (const key of ['lat','lng','radius']) values.delete(key);
  return values;
}

// Availability is supplied by the backend over the entire matching catalogue,
// independently of the selected category and the current result page.
function calendarWheelFilterKey(search) {
  const values = calendarFilterParameters(search);
  values.delete('type');
  values.delete('page');
  values.delete('discovery_seed');
  values.sort();
  return values.toString();
}

function calendarHasActiveFilters(search) {
  return [...calendarFilterParameters(search).keys()].some(key => !['page','discovery_seed'].includes(key));
}

function calendarSetCosmosPanel(dialog, panel = '', restoreFocus = false) {
  if (!dialog) return;
  const previous = dialog.dataset.mobilePanel || '';
  dialog.dataset.mobilePanel = ['categories','view'].includes(panel) ? panel : '';
  dialog.querySelectorAll('[data-cosmos-panel-toggle]').forEach(button => {
    button.setAttribute('aria-expanded',String(button.dataset.cosmosPanelToggle === dialog.dataset.mobilePanel));
    if (restoreFocus && previous === button.dataset.cosmosPanelToggle && button.getClientRects().length) button.focus({preventScroll:true});
  });
}

function calendarCreateRail({getResults, getView, fetchPage, reducedMotion, onAppend = () => {}}) {
  let results, values, request, revision = 0;
  let loadedPages = new Set();
  const viewport = () => results?.querySelector('[data-discovery-stage]');
  const boundary = direction => results?.querySelector(`.kk-pagination a[rel="${direction > 0 ? 'next' : 'prev'}"]`);
  const key = card => card.querySelector('.kk-card-image')?.getAttribute('href');
  const update = () => {
    const stage = viewport();
    if (!stage || getResults() !== results) return;
    const max = Math.max(0, stage.scrollWidth - stage.clientWidth);
    const busy = Boolean(request) || results.getAttribute('aria-busy') === 'true';
    const loaded = results.querySelectorAll('.kk-grid > .kk-card').length;
    results.querySelectorAll('[data-loaded-count]').forEach(label => { label.textContent = String(loaded); });
    results.querySelectorAll('[data-total-count]').forEach(label => { label.textContent = results.dataset.total || String(loaded); });
    results.querySelectorAll('[data-load-more]').forEach(button => {
      button.hidden = !boundary(1) && !boundary(-1);
      button.disabled = busy;
      button.setAttribute('aria-busy', String(Boolean(request)));
    });
    results.querySelectorAll('[data-rail-prev]').forEach(button => {
      button.disabled = busy || (stage.scrollLeft <= 2 && !boundary(-1) && (Boolean(boundary(1)) || max <= 2));
    });
    results.querySelectorAll('[data-rail-next]').forEach(button => {
      button.disabled = busy || (max <= 2 && !boundary(1));
      button.setAttribute('aria-busy', String(Boolean(request)));
    });
  };
  const cancel = () => {
    ++revision;
    request?.abort();
    request = null;
    if (results) delete results.dataset.railLoading;
    update();
  };
  const reset = parameters => {
    cancel();
    results = getResults();
    values = new URLSearchParams(parameters);
    loadedPages = new Set([Number(results?.dataset.page || 1)]);
    if (results) {
      results.dataset.railReady = 'true';
      // Separate from the older rail enhancement: cached JavaScript must keep
      // native pagination when newer markup/styles arrive before this bundle.
      results.dataset.catalogueReady = 'true';
    }
    update();
  };
  const move = async (direction, appendOnly = false) => {
    const stage = viewport();
    const view = getView();
    if (!stage || getResults() !== results || (!appendOnly && view !== 'rail') || request || results.getAttribute('aria-busy') === 'true') return false;
    const max = Math.max(0, stage.scrollWidth - stage.clientWidth);
    const step = Math.max(260, stage.clientWidth * .8);
    const behavior = reducedMotion() ? 'instant' : 'smooth';
    if (!appendOnly && (direction > 0 ? stage.scrollLeft < max - 2 : stage.scrollLeft > 2)) {
      stage.scrollBy({left:direction * step, behavior});
      return true;
    }
    const link = boundary(direction);
    if (!link) {
      if (appendOnly) return false;
      if (max > 2) stage.scrollTo({left:direction > 0 ? 0 : max, behavior});
      return max > 2;
    }
    const page = Number(new URL(link.getAttribute('href'), 'https://calendar.invalid').searchParams.get('page'));
    if (!Number.isInteger(page) || page < 1 || loadedPages.has(page)) return false;
    const parameters = new URLSearchParams(values);
    parameters.set('page', String(page));
    const current = ++revision, original = results;
    const pending = new AbortController();
    request = pending;
    original.dataset.railLoading = 'true';
    const error = original.querySelector('[data-rail-error]');
    if (error) error.hidden = true;
    update();
    try {
      const replacement = await fetchPage(parameters, pending.signal);
      if (current !== revision || pending.signal.aborted || getResults() !== original || getView() !== view) return false;
      const grid = stage.querySelector('.kk-grid');
      const seen = new Set([...grid.querySelectorAll('.kk-card')].map(key));
      const cards = [...replacement.querySelectorAll('.kk-grid > .kk-card')].filter(card => {
        const id = key(card);
        if (!id || seen.has(id)) return false;
        seen.add(id); return true;
      });
      const oldWidth = stage.scrollWidth, oldLeft = stage.scrollLeft;
      if (direction > 0) grid.append(...cards); else grid.prepend(...cards);
      // Keep the opposite boundary: the cosmos shows the entire loaded range.
      const incoming = replacement.querySelector(`.kk-pagination a[rel="${direction > 0 ? 'next' : 'prev'}"]`);
      if (incoming) link.replaceWith(incoming);
      else (link.closest('li') || link).remove();
      const pagination = original.querySelector('.kk-pagination');
      if (pagination && !pagination.querySelector('a')) pagination.replaceChildren();
      loadedPages.add(page);
      if (replacement.dataset.total !== undefined) {
        original.dataset.total = replacement.dataset.total;
        const count = original.querySelector('.kk-discovery-results-head h2 small');
        if (count) count.textContent = replacement.dataset.total;
      }
      if (view === 'rail' && direction < 0) stage.scrollTo({left:oldLeft + stage.scrollWidth - oldWidth, behavior:'instant'});
      if (!appendOnly) stage.scrollBy({left:direction * step, behavior});
      onAppend(parameters);
      return true;
    } catch (failure) {
      if (failure.name !== 'AbortError' && current === revision && getResults() === original && error) error.hidden = false;
      return false;
    } finally {
      if (current === revision) {
        request = null;
        delete original.dataset.railLoading;
        update();
      }
    }
  };
  const loadMore = () => move(boundary(1) ? 1 : -1, true);
  const loadRemaining = async () => {
    // Small selections fit the cosmos at once. Larger catalogues retain a
    // deliberate load button instead of making unbounded background requests.
    const total = Number(results?.dataset.total);
    if (getView() !== 'cosmos' || !Number.isInteger(total) || total < 1 || total > 100) return;
    const original = results;
    for (let page = 0; page < 6 && getResults() === original && getView() === 'cosmos'; page++) {
      if (!await loadMore()) break;
    }
  };
  return {reset, cancel, update, move, loadMore, loadRemaining};
}

function calendarNewDiscoverySeed(previous) {
  const seed = 1 + Math.floor(Math.random() * 2147483647);
  return String(seed) === String(previous) ? String(seed === 2147483647 ? 1 : seed + 1) : String(seed);
}

function calendarAvailableTypes(raw) {
  if (raw === null || raw === undefined) return null;
  try {
    const available = JSON.parse(raw);
    return Array.isArray(available) ? available : [];
  } catch (_) { return []; }
}

function calendarAvailableSectors(sectors, raw) {
  const available = calendarAvailableTypes(raw);
  return available === null ? sectors : sectors.filter(sector => available.includes(sector.dataset.wheelType));
}

function calendarResultCount(payload) {
  const cards = payload.querySelectorAll('.kk-card').length;
  const rawTotal = payload.getAttribute('data-total');
  const total = Number(rawTotal);
  return cards && (rawTotal !== null && Number.isFinite(total) && total >= 0 ? total : cards);
}

// Only a checked, non-empty payload can become a wheel result. Availability and
// candidate checks are separate requests because events can change meanwhile.
async function calendarFindWheelResult(sectors, search, fetchResults, signal, random = Math.random) {
  const active = () => {
    if (signal?.aborted) { const error = new Error('Cancelled'); error.name = 'AbortError'; throw error; }
  };
  const values = calendarFilterParameters(search);
  values.delete('type');
  values.delete('page');
  active();
  const availability = await fetchResults(values,signal);
  active();
  const pool = [...calendarAvailableSectors(sectors,availability.getAttribute('data-available-types'))];
  while (pool.length) {
    const [sector] = pool.splice(Math.floor(random() * pool.length),1);
    const candidateValues = new URLSearchParams(values);
    candidateValues.set('type',sector.dataset.wheelType);
    active();
    const payload = await fetchResults(candidateValues,signal);
    active();
    const count = calendarResultCount(payload);
    if (count) return {sector,values:candidateValues,payload,count};
  }
  return null;
}

function calendarClampCamera(camera, viewport, world) {
  const scale = Math.min(2.2,Math.max(.45,Number.isFinite(camera.scale) ? camera.scale : 1));
  const axis = (position,view,size) => size * scale <= view
    ? (view - size * scale) / 2
    : Math.max(view - size * scale - 24,Math.min(24,Number.isFinite(position) ? position : 0));
  return {x:axis(camera.x,viewport.width,world.width),y:axis(camera.y,viewport.height,world.height),scale};
}

function calendarZoomCamera(camera, scale, anchor, viewport, world) {
  scale = Math.min(2.2,Math.max(.45,scale));
  const ratio = scale / camera.scale;
  return calendarClampCamera({x:anchor.x - (anchor.x - camera.x) * ratio,y:anchor.y - (anchor.y - camera.y) * ratio,scale},viewport,world);
}

function calendarPinchCamera(camera, before, after, viewport, world) {
  const distance = points => Math.hypot(points[1].x-points[0].x,points[1].y-points[0].y);
  const middle = points => ({x:(points[0].x+points[1].x)/2,y:(points[0].y+points[1].y)/2});
  const start = middle(before);
  const end = middle(after);
  const scale = Math.min(2.2,Math.max(.45,camera.scale * distance(after) / Math.max(1,distance(before))));
  const ratio = scale / camera.scale;
  return calendarClampCamera({x:end.x-(start.x-camera.x)*ratio,y:end.y-(start.y-camera.y)*ratio,scale},viewport,world);
}

// All sound is synthesized locally after a user gesture. No file or network
// dependency is needed, and every scheduled voice is explicitly stoppable.
function calendarCreateWheelSound(createContext) {
  let context;
  let enabled = true;
  const voices = new Set();
  const stop = () => {
    for (const voice of voices) {
      try { voice.oscillator.stop(); } catch (_) { /* already ended */ }
      voice.oscillator.disconnect(); voice.gain.disconnect();
    }
    voices.clear();
  };
  const tone = (frequency,duration,volume,delay = 0) => {
    if (!enabled || context?.state !== 'running') return;
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const start = context.currentTime + delay;
    oscillator.type = 'triangle';
    oscillator.frequency.setValueAtTime(frequency,start);
    gain.gain.setValueAtTime(0.0001,start);
    gain.gain.exponentialRampToValueAtTime(volume,start+.004);
    gain.gain.exponentialRampToValueAtTime(.0001,start+duration);
    oscillator.connect(gain); gain.connect(context.destination);
    const voice = {oscillator,gain}; voices.add(voice);
    oscillator.onended = () => { voices.delete(voice); oscillator.disconnect(); gain.disconnect(); };
    oscillator.start(start); oscillator.stop(start+duration+.015);
  };
  return {
    get enabled() { return enabled; },
    prepare() {
      if (!enabled) return;
      try { context ||= createContext(); context?.resume()?.catch(()=>{}); } catch (_) { /* audio is optional */ }
    },
    setEnabled(value) { enabled = Boolean(value); if (!enabled) stop(); },
    tick() { tone(850,.026,.032); },
    success() { [261.63,329.63,392].forEach((frequency,index)=>tone(frequency,.55,.022,index*.045)); },
    stop
  };
}

// Shopify renders the first result page as crawlable HTML. The same signed app
// proxy supplies both the normal list and the enhanced discovery experience.
document.querySelectorAll('[data-storefront-calendar]').forEach(calendar => {
  const form = calendar.querySelector('[data-calendar-filters]');
  const allowed = ['q','city','month','from','to','type','art_form','lat','lng','radius','page','discovery_seed'];
  const discovery = calendar.hasAttribute('data-calendar-discovery');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const parameters = calendarFilterParameters;
  let pending;
  let revision = 0;
  let debounce;
  let composing = false;
  let rotation = 0;
  let spinTimer;
  let finishSpin;
  let spinning = false;
  let preparingSpin = false;
  let spinRevision = 0;
  let discoverySeed;
  let wheelPending;
  let wheelCandidate;
  let showingWheelResult = false;
  const rotor = calendar.querySelector('[data-wheel-rotor]');
  const spinButton = calendar.querySelector('[data-wheel-spin]');
  const wheelStatus = calendar.querySelector('[data-wheel-status]');
  const wheelResultCopy = calendar.querySelector('[data-wheel-result-copy]');
  const wheelSoundButton = calendar.querySelector('[data-wheel-sound]');
  const wheelSound = calendarCreateWheelSound(() => {
    const Audio = window.AudioContext || window.webkitAudioContext;
    return Audio ? new Audio() : null;
  });
  let audioFrame;
  let cosmosController;
  let motionWanted = true;
  const cardTransitions = new WeakMap();
  const sectors = [...calendar.querySelectorAll('[data-wheel-type]')];
  const wheelPanel = calendar.querySelector('.kk-wheel-panel');
  const wheelHome = calendar.querySelector('[data-wheel-home]');
  const wheelDialog = calendar.querySelector('[data-wheel-dialog]');
  const wheelModalStage = calendar.querySelector('[data-wheel-modal-stage]');
  const wheelActions = calendar.querySelector('[data-wheel-actions]');
  const wheelShow = calendar.querySelector('[data-wheel-show]');
  const wheelAgain = calendar.querySelector('[data-wheel-again]');
  const cosmosDialog = calendar.querySelector('[data-cosmos-dialog]');
  const compactCosmos = window.matchMedia('(max-width: 760px)');
  const cosmosModalStage = calendar.querySelector('[data-cosmos-modal-stage]');
  const resultsHome = calendar.querySelector('[data-results-home]');
  const scrollLocks = new Set();
  let savedScroll;
  let wheelReturnFocus;
  let cosmosReturnFocus;
  let wheelHomeHeight;
  let resultsHomeHeight;
  const hasFilters = calendarHasActiveFilters;
  const formParameters = () => {
    const values = parameters(new URLSearchParams(new FormData(form)));
    if (discovery && discoverySeed) values.set('discovery_seed',discoverySeed);
    return values;
  };
  const readNavigation = () => {
    const values = parameters(location.search);
    const saved = history.state?.kkDiscovery;
    // Exact location stays in this tab's history state, not in public URLs or
    // language links. Back/forward still restores a deliberately chosen radius.
    if (discovery && saved?.url === location.pathname + location.search && saved.geo) {
      for (const name of ['lat','lng','radius']) if (saved.geo[name]) values.set(name, saved.geo[name]);
    }
    return values;
  };
  const publicParameters = values => {
    const shareable = new URLSearchParams(values);
    if (discovery) for (const key of ['lat','lng','radius']) shareable.delete(key);
    return shareable;
  };
  const restore = (values = readNavigation()) => {
    if (!form) return;
    for (const input of form.elements) {
      const key = input.name === 'calendar_query' ? 'q' : input.name;
      if (key && allowed.includes(key)) input.value = values.get(key) || (key === 'radius' ? '25' : '');
    }
  };
  const links = values => {
    values = publicParameters(values);
    values.delete('page');
    calendar.querySelectorAll('[data-calendar-language]').forEach(link => {
      const target = new URL(link.href);
      target.search = values.toString();
      link.href = target.href;
    });
  };
  const resultCards = () => [...calendar.querySelectorAll('[data-discovery-stage] .kk-card')];
  const stage = () => calendar.querySelector('[data-discovery-stage]');
  const label = (key, fallback = '') => calendar.dataset[key] || fallback;
  const setWheelStatus = text => {
    if (wheelStatus) wheelStatus.textContent = text;
    if (wheelResultCopy) wheelResultCopy.textContent = text;
  };
  const syncSound = () => {
    if (!wheelSoundButton) return;
    wheelSoundButton.setAttribute('aria-pressed',String(wheelSound.enabled));
    wheelSoundButton.textContent = label(wheelSound.enabled ? 'labelSoundOn' : 'labelSoundOff',wheelSoundButton.textContent);
    wheelSoundButton.setAttribute('aria-label',wheelSoundButton.textContent);
  };
  const stopWheelAudio = () => { cancelAnimationFrame(audioFrame); audioFrame = null; wheelSound.stop(); };
  const startWheelTicks = () => {
    cancelAnimationFrame(audioFrame);
    if (!wheelSound.enabled || document.hidden || !rotor) return;
    const angle = () => {
      const numbers = getComputedStyle(rotor).transform.match(/^matrix\(([^)]+)\)$/)?.[1].split(',').map(Number);
      return numbers ? Math.atan2(numbers[1],numbers[0]) * 180 / Math.PI : 0;
    };
    let previous = angle(), travel = 0, previousPeg = 0, lastTick = 0;
    const frame = time => {
      if (!spinning || !wheelSound.enabled || document.hidden) return;
      const next = angle();
      const delta = (next - previous + 360) % 360;
      previous = next;
      // A hidden/throttled frame must never replay a burst of missed clicks.
      if (delta < 180) travel += delta;
      const peg = Math.floor(travel / 12);
      if (peg > previousPeg && time - lastTick >= 35) { wheelSound.tick(); lastTick = time; }
      previousPeg = peg;
      audioFrame = requestAnimationFrame(frame);
    };
    audioFrame = requestAnimationFrame(frame);
  };
  const syncMotion = () => {
    const running = motionWanted && !reducedMotion.matches && !document.hidden;
    calendar.dataset.cosmosMotion = running ? 'running' : 'paused';
    calendar.querySelectorAll('button[data-cosmos-motion]').forEach(button => {
      button.setAttribute('aria-pressed',String(running));
      button.disabled = reducedMotion.matches;
      button.textContent = label(running ? 'labelMotionOn' : 'labelMotionOff',button.textContent);
      button.setAttribute('aria-label',button.textContent);
    });
  };
  const syncCategories = values => {
    const raw = calendar.querySelector('[data-calendar-results]')?.getAttribute('data-available-types');
    const available = calendarAvailableTypes(raw);
    let hiddenFocus = false;
    const currentCategory = calendar.querySelector('[data-cosmos-current-category]');
    const mobileCount = calendar.querySelector('[data-cosmos-mobile-count]');
    if (mobileCount) mobileCount.textContent = calendar.querySelector('[data-calendar-results]')?.dataset.total || '0';
    calendar.querySelectorAll('[data-cosmos-category]').forEach(button => {
      const type = button.dataset.cosmosCategory;
      button.setAttribute('aria-pressed',String(type === (values.get('type') || '')));
      if (currentCategory && type === (values.get('type') || '')) currentCategory.textContent = button.textContent.trim();
      button.hidden = Boolean(type && available !== null && !available.includes(type));
      button.disabled = button.hidden;
      if (button.hidden && button.contains(document.activeElement)) hiddenFocus = true;
      if (button.disabled) {
        const text = label('labelCategoryEmpty',':category').replace(':category',button.textContent.trim());
        button.title = text; button.setAttribute('aria-label',text);
      } else { button.removeAttribute('title'); button.removeAttribute('aria-label'); }
    });
    if (hiddenFocus) calendar.querySelector('[data-cosmos-category=""]')?.focus({preventScroll:true});
  };
  let wheelModalActive = false;
  let cosmosModalActive = false;
  const lockScroll = dialog => {
    if (scrollLocks.has(dialog)) return;
    if (!scrollLocks.size) {
      savedScroll = {x:window.scrollX,y:window.scrollY,html:document.documentElement.style.overflow,body:document.body.style.overflow,padding:document.body.style.paddingRight};
      const scrollbar = Math.max(0,window.innerWidth - document.documentElement.clientWidth);
      if (scrollbar) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    scrollLocks.add(dialog);
  };
  const unlockScroll = dialog => {
    scrollLocks.delete(dialog);
    if (scrollLocks.size || !savedScroll) return;
    document.documentElement.style.overflow = savedScroll.html;
    document.body.style.overflow = savedScroll.body;
    document.body.style.paddingRight = savedScroll.padding;
    window.scrollTo({left:savedScroll.x,top:savedScroll.y,behavior:'instant'});
    savedScroll = null;
  };
  const cleanupWheelDialog = (focus = true) => {
    if (!wheelModalActive) return;
    wheelModalActive = false;
    cancelSpin();
    if (wheelPanel && wheelHome) { wheelHome.append(wheelPanel); wheelHome.style.minHeight = wheelHomeHeight || ''; }
    if (wheelActions) wheelActions.hidden = true;
    wheelDialog?.removeAttribute('data-wheel-phase');
    unlockScroll(wheelDialog);
    announceSelection(form?.elements.namedItem('type')?.value);
    if (focus && wheelReturnFocus?.isConnected) wheelReturnFocus.focus({preventScroll:true});
  };
  const closeWheelDialog = (focus = true) => {
    if (wheelDialog?.open) wheelDialog.close();
    cleanupWheelDialog(focus);
  };
  const openWheelDialog = trigger => {
    if (wheelDialog?.open) return true;
    if (!wheelDialog?.showModal || !wheelModalStage || !wheelPanel) return false;
    wheelReturnFocus = trigger?.focus ? trigger : document.activeElement;
    if (wheelHome) { wheelHomeHeight = wheelHome.style.minHeight; wheelHome.style.minHeight = `${wheelHome.getBoundingClientRect().height}px`; }
    wheelModalStage.append(wheelPanel);
    wheelModalActive = true;
    if (wheelActions) wheelActions.hidden = true;
    wheelDialog.dataset.wheelPhase = 'checking';
    wheelDialog.showModal();
    lockScroll(wheelDialog);
    wheelDialog.querySelector('[data-wheel-close]')?.focus({preventScroll:true});
    return true;
  };
  const cleanupCosmosDialog = (focus = true) => {
    if (!cosmosModalActive) return;
    cosmosModalActive = false;
    calendarSetCosmosPanel(cosmosDialog);
    const results = cosmosModalStage?.querySelector('[data-calendar-results]');
    if (results && resultsHome) { resultsHome.append(results); resultsHome.style.minHeight = resultsHomeHeight || ''; }
    cosmosController?.stopGesture();
    cosmosController?.refresh();
    unlockScroll(cosmosDialog);
    updateRail();
    if (focus) {
      const target = cosmosReturnFocus?.isConnected ? cosmosReturnFocus : results?.querySelector('h2');
      if (target?.tagName === 'H2') target.tabIndex = -1;
      target?.focus({preventScroll:true});
    }
  };
  const closeCosmosDialog = (focus = true) => {
    if (cosmosDialog?.open) cosmosDialog.close();
    cleanupCosmosDialog(focus);
  };
  const openCosmosDialog = trigger => {
    setView('cosmos',false);
    if (cosmosDialog?.open) return;
    const results = calendar.querySelector('[data-calendar-results]');
    if (!results) return;
    if (!cosmosDialog?.showModal || !cosmosModalStage) {
      results.scrollIntoView({block:'start',behavior:reducedMotion.matches ? 'instant' : 'smooth'});
      return;
    }
    // Keep the underlying page exactly where it was. The top-layer dialog's
    // entrance animation supplies the transition without a background jump.
    cosmosReturnFocus = trigger?.isConnected && !trigger.closest('[data-wheel-dialog]') ? trigger : results.querySelector('h2');
    if (cosmosReturnFocus?.tagName === 'H2') cosmosReturnFocus.tabIndex = -1;
    if (resultsHome) { resultsHomeHeight = resultsHome.style.minHeight; resultsHome.style.minHeight = `${resultsHome.getBoundingClientRect().height}px`; }
    cosmosModalStage.append(results);
    cosmosModalActive = true;
    const error = cosmosDialog.querySelector('[data-cosmos-error]');
    if (error) error.hidden = true;
    calendarSetCosmosPanel(cosmosDialog);
    cosmosDialog.showModal();
    lockScroll(cosmosDialog);
    cosmosDialog.querySelector('[data-cosmos-close]')?.focus({preventScroll:true});
    stage()?.scrollTo({left:0,top:0,behavior:'instant'});
    connectStage();
    cosmosController?.refresh();
    animateCards();
  };
  const announceSelection = value => {
    const selected = sectors.find(sector => sector.dataset.wheelType === value);
    setWheelStatus(selected
      ? label('labelSelected', ':category').replace(':category', selected.dataset.label || selected.textContent.trim())
      : label('labelInitial'));
  };
  const syncSelected = values => {
    if (!discovery) return;
    const selected = values.get('type') || '';
    syncCategories(values);
    sectors.forEach(sector => {
      const active = sector.dataset.wheelType === selected;
      sector.toggleAttribute('data-selected', active);
      if (active) sector.setAttribute('aria-current', 'true');
      else sector.removeAttribute('aria-current');
    });
    if (!spinning) announceSelection(selected);
    const summary = calendar.querySelector('[data-filter-summary]');
    if (summary && form) {
      summary.replaceChildren();
      for (const [name, value] of values) {
        if (['page','lat','lng','radius','discovery_seed'].includes(name)) continue;
        const input = form.elements.namedItem(name === 'q' ? 'calendar_query' : name);
        const display = input?.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() || value : value;
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kk-filter-chip';
        chip.dataset.removeFilter = name;
        chip.textContent = display + ' ×';
        chip.setAttribute('aria-label', label('labelRemove', ':filter ×').replace(':filter', display));
        summary.append(chip);
      }
      if (values.has('lat') && values.has('lng')) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kk-filter-chip';
        chip.dataset.removeFilter = 'location';
        const display = form.querySelector('[data-near-me]')?.textContent.trim() || '';
        chip.textContent = display + ' · ' + (values.get('radius') || '25') + ' km ×';
        chip.setAttribute('aria-label', label('labelRemove', ':filter ×').replace(':filter', display));
        summary.append(chip);
      }
      summary.hidden = !summary.childElementCount;
    }
  };
  const cancelSpin = () => {
    ++spinRevision;
    clearTimeout(spinTimer);
    finishSpin = null;
    stopWheelAudio();
    wheelPending?.abort();
    wheelCandidate = null;
    showingWheelResult = false;
    if (wheelActions) wheelActions.hidden = true;
    if (wheelShow) wheelShow.disabled = false;
    if (wheelAgain) wheelAgain.disabled = false;
    if (spinning && rotor) {
      const transform = getComputedStyle(rotor).transform;
      if (transform && transform !== 'none') {
        const matrix = transform.match(/^matrix\(([^)]+)\)$/)?.[1].split(',').map(Number);
        if (matrix) rotation = Math.atan2(matrix[1], matrix[0]) * 180 / Math.PI;
      }
      rotor.style.transition = 'none';
      rotor.style.transform = `rotate(${rotation}deg)`;
    }
    spinning = false;
    preparingSpin = false;
    calendar.dataset.wheelSpinning = 'false';
    if (spinButton) { spinButton.disabled = false; spinButton.removeAttribute('aria-busy'); }
  };
  const railController = discovery ? calendarCreateRail({
    getResults:() => calendar.querySelector('[data-calendar-results]'),
    getView:() => calendar.dataset.discoveryView,
    fetchPage:fetchResults,
    reducedMotion:() => reducedMotion.matches,
    onAppend:values => { cosmosController?.refresh(); syncCategories(values); }
  }) : null;
  const updateRail = () => railController?.update();
  const animateCards = previous => {
    if (reducedMotion.matches) return;
    resultCards().forEach((card, index) => {
      if (!card.animate) return;
      // Floating is a CSS animation. Cancel only our own entrance/FLIP effect.
      cardTransitions.get(card)?.cancel();
      const target = card.getBoundingClientRect();
      const old = previous?.get(card);
      const finalTransform = getComputedStyle(card).transform;
      const base = finalTransform === 'none' ? '' : finalTransform;
      const start = old
        ? `translate(${old.left - target.left}px, ${old.top - target.top}px) scale(${old.width / target.width}, ${old.height / target.height}) ${base}`
        : `translateY(22px) scale(.97) ${base}`;
      const transition = card.animate([{opacity:old ? 1 : 0, transform:start},{opacity:1, transform:finalTransform}], {
        duration:old ? 600 : 440, delay:Math.min(index * 28, 280), easing:'cubic-bezier(.22,.61,.36,1)', fill:'backwards'
      });
      cardTransitions.set(card,transition);
    });
  };
  const setView = (view, animate = true) => {
    if (!discovery) return;
    view = view === 'cosmos' ? 'cosmos' : 'rail';
    const changed = calendar.dataset.discoveryView !== view;
    if (changed) railController?.cancel();
    const previous = changed && animate ? new Map(resultCards().map(card => [card,card.getBoundingClientRect()])) : null;
    calendar.dataset.discoveryView = view;
    cosmosController?.refresh();
    syncMotion();
    calendar.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
    const title = calendar.querySelector('[data-discovery-heading]');
    if (title) title.textContent = view === 'cosmos' ? label('labelCosmos', title.textContent) : label('labelRail', title.textContent);
    if (changed && animate) animateCards(previous);
    updateRail();
    if (view === 'cosmos') railController?.loadRemaining();
  };
  const connectStage = () => {
    const viewport = stage();
    if (cosmosController?.viewport === viewport) { cosmosController.refresh(); return; }
    cosmosController?.destroy();
    cosmosController = null;
    if (!viewport) return;
    const world = viewport.querySelector('[data-cosmos-world]') || viewport.querySelector('.kk-grid');
    const listeners = new AbortController();
    const signal = listeners.signal;
    const pointers = new Map();
    let camera = {x:0,y:0,scale:1};
    let gesture;
    let dragged = false;
    let suppressClickUntil = 0;
    let interactionTimer;
    let refreshFrame;
    let focusFrame;
    let transitionTimer;
    let observer;
    const active = () => Boolean(world && calendar.dataset.discoveryView === 'cosmos');
    const viewSize = () => ({width:viewport.clientWidth,height:viewport.clientHeight});
    const worldSize = () => ({width:world?.offsetWidth || 0,height:world?.offsetHeight || 0});
    const position = event => {
      const box = viewport.getBoundingClientRect();
      return {x:event.clientX-box.left,y:event.clientY-box.top};
    };
    const render = () => {
      const enabled = active();
      viewport.dataset.cosmosCamera = String(enabled);
      if (world) {
        if (enabled) {
          camera = calendarClampCamera(camera,viewSize(),worldSize());
          world.style.transform = `translate3d(${camera.x}px,${camera.y}px,0) scale(${camera.scale})`;
          viewport.scrollLeft = 0; viewport.scrollTop = 0;
        } else { world.style.transform = ''; world.style.transition = ''; }
      }
      calendar.querySelectorAll('[data-cosmos-zoom-value]').forEach(output => { output.textContent = `${Math.round(camera.scale*100)}%`; });
      calendar.querySelectorAll('[data-cosmos-zoom-in]').forEach(button => { button.disabled = !enabled || camera.scale >= 2.2-.001; });
      calendar.querySelectorAll('[data-cosmos-zoom-out]').forEach(button => { button.disabled = !enabled || camera.scale <= .45+.001; });
      updateRail();
    };
    const interacting = () => {
      clearTimeout(interactionTimer);
      viewport.dataset.cosmosInteracting = 'true';
      if (world) world.style.transition = 'none';
      interactionTimer = setTimeout(() => { if (!pointers.size) viewport.removeAttribute('data-cosmos-interacting'); },180);
    };
    const zoom = (factor,anchor = {x:viewport.clientWidth/2,y:viewport.clientHeight/2}) => {
      if (!active()) return;
      interacting();
      camera = calendarZoomCamera(camera,camera.scale*factor,anchor,viewSize(),worldSize());
      render();
    };
    const stopGesture = () => {
      const ids = [...pointers.keys()];
      pointers.clear(); gesture = null;
      if (dragged) suppressClickUntil = performance.now()+450;
      dragged = false;
      for (const id of ids) { try { if (viewport.hasPointerCapture(id)) viewport.releasePointerCapture(id); } catch (_) { /* pointer already released */ } }
      viewport.removeAttribute('data-cosmos-interacting');
      clearTimeout(interactionTimer);
    };
    const beginGesture = () => {
      gesture = {camera:{...camera},points:[...pointers.values()].slice(0,2).map(point=>({...point}))};
    };
    const capture = () => {
      for (const id of pointers.keys()) { try { viewport.setPointerCapture(id); } catch (_) { /* inactive pointer */ } }
    };
    viewport.addEventListener('scroll',updateRail,{passive:true,signal});
    viewport.addEventListener('dragstart',event=>{ if (active()) event.preventDefault(); },{signal});
    viewport.addEventListener('pointerdown',event=>{
      if (!active() || (event.pointerType === 'mouse' && event.button !== 0) || event.target.closest('button,input,select,textarea,summary,details')) return;
      if (pointers.size >= 2) return;
      pointers.set(event.pointerId,position(event));
      if (pointers.size === 1) dragged = false;
      beginGesture();
      if (pointers.size === 2) { dragged = true; interacting(); capture(); event.preventDefault(); }
      // Do not capture or prevent a single tap: native links still receive it.
    },{signal});
    window.addEventListener('pointermove',event=>{
      if (!active() || !pointers.has(event.pointerId) || !gesture) return;
      pointers.set(event.pointerId,position(event));
      const points = [...pointers.values()].slice(0,2);
      if (points.length === 2 && gesture.points.length === 2) {
        dragged = true;
        camera = calendarPinchCamera(gesture.camera,gesture.points,points,viewSize(),worldSize());
      } else {
        const dx = points[0].x-gesture.points[0].x;
        const dy = points[0].y-gesture.points[0].y;
        if (!dragged && Math.hypot(dx,dy) < 7) return;
        dragged = true;
        camera = calendarClampCamera({...gesture.camera,x:gesture.camera.x+dx,y:gesture.camera.y+dy},viewSize(),worldSize());
      }
      interacting(); capture(); event.preventDefault(); render();
    },{passive:false,signal});
    const pointerUp = event => {
      if (!pointers.has(event.pointerId)) return;
      pointers.delete(event.pointerId);
      try { if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId); } catch (_) { /* already released */ }
      if (pointers.size) beginGesture(); else stopGesture();
    };
    window.addEventListener('pointerup',pointerUp,{signal});
    window.addEventListener('pointercancel',event=>{ if (pointers.has(event.pointerId)) stopGesture(); },{signal});
    viewport.addEventListener('lostpointercapture',event=>{
      // Touch starts with implicit capture on the tapped child. Transferring it
      // to the stage for dragging emits a bubbling loss on that child; it is
      // not cancellation of the stage's newly established gesture capture.
      if (event.target === viewport && pointers.has(event.pointerId) && !viewport.hasPointerCapture(event.pointerId)) stopGesture();
    },{signal});
    viewport.addEventListener('click',event=>{
      if (active() && event.detail !== 0 && performance.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    },{capture:true,signal});
    viewport.addEventListener('wheel',event=>{
      if (!active() || event.target.closest('input,select,textarea,details[open]')) return;
      event.preventDefault();
      const delta = event.deltaY*(event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientHeight : 1);
      if (event.target.closest('.kk-card') || event.ctrlKey) {
        // Cards zoom around the pointer. Ctrl-wheel also preserves the native
        // trackpad pinch gesture, which browsers dispatch as a wheel event.
        zoom(Math.exp(-Math.max(-150,Math.min(150,delta))*.002),position(event));
      } else {
        interacting();
        camera.y -= delta;
        render();
      }
    },{passive:false,signal});
    viewport.addEventListener('keydown',event=>{
      if (!active() || event.target !== viewport || event.ctrlKey || event.metaKey || event.altKey) return;
      if (['+','='].includes(event.key)) { event.preventDefault(); zoom(1.2); }
      else if (event.key === '-') { event.preventDefault(); zoom(1/1.2); }
      else if (['0','Home'].includes(event.key)) { event.preventDefault(); camera={x:0,y:0,scale:1}; render(); }
      else if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) {
        event.preventDefault(); interacting();
        camera.x += event.key === 'ArrowLeft' ? 90 : event.key === 'ArrowRight' ? -90 : 0;
        camera.y += event.key === 'ArrowUp' ? 90 : event.key === 'ArrowDown' ? -90 : 0;
        render();
      }
    },{signal});
    viewport.addEventListener('focusin',event=>{
      if (!active() || event.target === viewport || !world?.contains(event.target)) return;
      cancelAnimationFrame(focusFrame);
      focusFrame = requestAnimationFrame(()=>{
        if (!active() || !event.target.isConnected) return;
        viewport.scrollLeft=0; viewport.scrollTop=0;
        const target=event.target.getBoundingClientRect(), box=viewport.getBoundingClientRect();
        const delta=(start,end,min,max)=>start < min ? min-start : end > max ? max-end : 0;
        camera.x += delta(target.left,target.right,box.left+20,box.right-20);
        camera.y += delta(target.top,target.bottom,box.top+20,box.bottom-20);
        if (world) world.style.transition=reducedMotion.matches ? 'none' : 'transform 220ms ease-out';
        render(); clearTimeout(transitionTimer);
        transitionTimer=setTimeout(()=>{ if (world) world.style.transition=''; },230);
      });
    },{signal});
    const refresh = () => {
      if (world) world.dataset.cardCount = String(world.querySelectorAll('.kk-card').length);
      if (!active()) stopGesture();
      render(); syncMotion();
    };
    const scheduleRefresh = () => { cancelAnimationFrame(refreshFrame); refreshFrame=requestAnimationFrame(refresh); };
    if (window.ResizeObserver) { observer=new ResizeObserver(scheduleRefresh); observer.observe(viewport); if (world) observer.observe(world); }
    window.addEventListener('resize',scheduleRefresh,{passive:true,signal});
    cosmosController = {
      viewport,refresh,zoom,stopGesture,
      reset() { stopGesture(); camera={x:0,y:0,scale:1}; render(); },
      destroy() { stopGesture(); listeners.abort(); observer?.disconnect(); cancelAnimationFrame(refreshFrame); cancelAnimationFrame(focusFrame); clearTimeout(transitionTimer); }
    };
    refresh();
  };
  const validForm = (report = true) => {
    if (!form) return false;
    const from = form.elements.namedItem('from');
    const to = form.elements.namedItem('to');
    if (to) {
      to.setCustomValidity('');
      if (from?.value && to.value && from.value > to.value) to.setCustomValidity(label('labelDateOrder', form.dataset.error || 'Please check the date range.'));
    }
    if (form.checkValidity()) return true;
    if (report) {
      const invalid = form.querySelector(':invalid');
      const details = invalid?.closest('details');
      if (details) details.open = true;
      form.reportValidity();
    }
    return false;
  };
  const invalidate = () => {
    clearTimeout(debounce);
    railController?.cancel();
    pending?.abort();
    ++revision;
    calendar.querySelector('[data-calendar-results]')?.removeAttribute('aria-busy');
    updateRail();
  };
  // Each localized metaobject has its own native URL. Keep the shop header's
  // language selector on that counterpart, including the current month/filter.
  document.addEventListener('change', event => {
    const select = event.target;
    if (select.id !== 'FleuryHeaderLanguage') return;
    const locale = select.value.toLowerCase().split('-')[0];
    const target = [...calendar.querySelectorAll('[data-calendar-language]')].find(link => link.textContent.trim().toLowerCase() === locale);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const languageTarget = new URL(target.href, location.href);
    if (location.hash.startsWith('#verwaltung') || ['#eintragen','#konto','#anmelden','#kunstbrief','#bestaetigen'].includes(location.hash)) languageTarget.hash = location.hash;
    location.assign(languageTarget.href);
  }, true);
  async function fetchResults(values, signal) {
    const results = calendar.querySelector('[data-calendar-results]');
    if (!results) throw new Error('Missing calendar');
    const endpoint = new URL(results.dataset.endpoint, location.origin);
    endpoint.search = values.toString();
    const response = await fetch(endpoint, {headers:{Accept:'application/json'},signal,cache:'no-store'});
    if (!response.ok) throw new Error('Filter request failed');
    const body = await response.json();
    if (typeof body.html !== 'string') throw new Error('Invalid filter response');
    const template = document.createElement('template');
    template.innerHTML = body.html;
    const replacement = template.content.querySelector('[data-calendar-results]');
    if (!replacement) throw new Error('Missing results');
    return replacement;
  }
  function commitResults(replacement, values, push = true, desiredView = null) {
    const results = calendar.querySelector('[data-calendar-results]');
    if (!results) return;
    const focused = results.contains(document.activeElement);
    results.replaceWith(replacement);
    railController?.reset(values);
    // The private portal owns the address while it is open. A late catalogue
    // response must not replace its view fragment with public filter state.
    const portalOpen = ['#eintragen','#konto','#anmelden','#kunstbrief','#bestaetigen'].includes(location.hash) || location.hash?.startsWith('#verwaltung/');
    if (push && !portalOpen) {
      const shareable = publicParameters(values);
      const url = location.pathname + (shareable.size ? '?' + shareable : '');
      const state = {...(history.state || {})};
      if (discovery) state.kkDiscovery = {url,geo:Object.fromEntries([...values].filter(([key]) => ['lat','lng','radius'].includes(key)))};
      if (url !== location.pathname + location.search || JSON.stringify(state.kkDiscovery) !== JSON.stringify(history.state?.kkDiscovery)) {
        history[push === 'replace' ? 'replaceState' : 'pushState'](state,'',url);
      }
    }
    links(values);
    if (discovery) {
      discoverySeed = values.get('discovery_seed') || discoverySeed;
      restore(values);
      syncSelected(values);
      setView(desiredView === 'preserve' ? calendar.dataset.discoveryView : desiredView || (hasFilters(values) ? 'cosmos' : 'rail'), false);
      connectStage();
      if (desiredView !== 'preserve') animateCards();
      if (focused) {
        const compactDialog = cosmosDialog?.open && cosmosDialog.hasAttribute('data-cosmos-compact');
        const target = replacement.querySelector(compactDialog ? '[data-discovery-stage]' : 'h2');
        if (target) {
          if (!compactDialog) target.tabIndex = -1;
          target.focus({preventScroll:true});
        }
      }
    }
  }
  async function load(values, push = true, desiredView = null) {
    values = new URLSearchParams(values);
    if (discovery && discoverySeed && !values.has('discovery_seed')) values.set('discovery_seed',discoverySeed);
    const results = calendar.querySelector('[data-calendar-results]');
    if (!results) return false;
    railController?.cancel();
    pending?.abort();
    pending = new AbortController();
    const current = ++revision;
    const error = calendar.querySelector('[data-calendar-error]');
    if (error) error.hidden = true;
    const modalError = cosmosDialog?.querySelector('[data-cosmos-error]');
    if (modalError) modalError.hidden = true;
    results.setAttribute('aria-busy','true');
    try {
      const replacement = await fetchResults(values,pending.signal);
      if (current !== revision) return;
      commitResults(replacement,values,push,desiredView);
      return true;
    } catch (failure) {
      if (failure.name !== 'AbortError' && current === revision) {
        if (cosmosDialog?.open && modalError) { modalError.textContent = form?.dataset.error || calendar.dataset.filterError; modalError.hidden = false; }
        if (error) { error.textContent = form?.dataset.error || calendar.dataset.filterError; error.hidden = false; }
        else {
          let notice = calendar.querySelector('[data-calendar-load-error]');
          if (!notice) { notice = document.createElement('p'); notice.dataset.calendarLoadError = ''; notice.setAttribute('role','alert'); results.prepend(notice); }
          notice.textContent = calendar.dataset.filterError || 'Please try again.';
        }
      }
      return false;
    } finally {
      if (current === revision) calendar.querySelector('[data-calendar-results]')?.removeAttribute('aria-busy');
      updateRail();
    }
  }
  const wheelNotice = (empty = false) => {
    stopWheelAudio();
    spinning = false;
    preparingSpin = false;
    showingWheelResult = false;
    wheelCandidate = null;
    calendar.dataset.wheelSpinning = 'false';
    if (spinButton) { spinButton.disabled = false; spinButton.removeAttribute('aria-busy'); }
    if (wheelAgain) wheelAgain.disabled = false;
    if (wheelShow) { wheelShow.disabled = true; wheelShow.hidden = true; }
    if (wheelActions) wheelActions.hidden = false;
    if (wheelDialog) wheelDialog.dataset.wheelPhase = empty ? 'empty' : 'error';
    setWheelStatus(empty ? label('labelNoMatch') : form?.dataset.error || calendar.dataset.filterError);
  };
  async function startWheelSpin(trigger) {
    if (spinning || preparingSpin || showingWheelResult || !rotor || !sectors.length || composing || !validForm()) return;
    if (!openWheelDialog(trigger)) return;
    // Resume synchronously in the click/keyboard gesture, before network awaits
    // (required by iOS and other browsers with user-activation audio policies).
    wheelSound.prepare();
    invalidate();
    cancelSpin();
    const ticket = ++spinRevision;
    wheelPending = new AbortController();
    preparingSpin = true;
    if (wheelShow) wheelShow.hidden = false;
    if (wheelActions) wheelActions.hidden = true;
    spinButton.disabled = true;
    spinButton.setAttribute('aria-busy','true');
    wheelDialog.dataset.wheelPhase = 'checking';
    setWheelStatus(label('labelChecking',label('labelLoading')));
    try {
      // This is always fresh, even when no control changed. It does not replace
      // the page's results or commit the tentative category to form/history.
      const result = await calendarFindWheelResult(sectors,formParameters(),fetchResults,wheelPending.signal);
      if (ticket !== spinRevision || !wheelDialog.open) return;
      preparingSpin = false;
      if (!result) { wheelNotice(true); return; }
      spinning = true;
      calendar.dataset.wheelSpinning = 'true';
      wheelDialog.dataset.wheelPhase = 'spinning';
      setWheelStatus(label('labelSpinning'));
      rotation = calendarWheelDestination(rotation,calendarWheelAngle(result.sector,sectors.length),4 + Math.floor(Math.random() * 2));
      rotor.style.transition = reducedMotion.matches ? 'none' : 'transform 7200ms cubic-bezier(.12,.67,.12,1)';
      rotor.style.transform = `rotate(${rotation}deg)`;
      if (!reducedMotion.matches) startWheelTicks();
      const finish = () => {
        if (ticket !== spinRevision || !wheelDialog.open) return;
        finishSpin = null;
        stopWheelAudio();
        if (!document.hidden) wheelSound.success();
        spinning = false;
        calendar.dataset.wheelSpinning = 'false';
        spinButton.disabled = false;
        spinButton.removeAttribute('aria-busy');
        wheelCandidate = result;
        wheelDialog.dataset.wheelPhase = 'result';
        setWheelStatus(label(result.count === 1 ? 'labelResultOne' : 'labelResult',':category · :count')
          .replace(':category',result.sector.dataset.label || result.sector.textContent.trim()).replace(':count',String(result.count)));
        if (wheelShow) { wheelShow.hidden = false; wheelShow.disabled = false; }
        if (wheelAgain) wheelAgain.disabled = false;
        if (wheelActions) wheelActions.hidden = false;
      };
      finishSpin = finish;
      spinTimer = setTimeout(finish,reducedMotion.matches ? 0 : 7200);
    } catch (failure) {
      if (failure.name !== 'AbortError' && ticket === spinRevision && wheelDialog.open) wheelNotice();
    }
  }
  async function showWheelResult() {
    if (!wheelCandidate || showingWheelResult || spinning || preparingSpin) return;
    const candidate = wheelCandidate;
    const ticket = ++spinRevision;
    wheelPending?.abort();
    wheelPending = new AbortController();
    showingWheelResult = true;
    if (wheelShow) wheelShow.disabled = true;
    if (wheelAgain) wheelAgain.disabled = true;
    if (spinButton) spinButton.disabled = true;
    setWheelStatus(label('labelChecking',label('labelLoading')));
    try {
      // Recheck after the long spin: a removed event must never produce an empty
      // success screen. Keep the dialog open with another-spin action instead.
      const payload = await fetchResults(candidate.values,wheelPending.signal);
      if (ticket !== spinRevision || !wheelDialog?.open) return;
      if (!calendarResultCount(payload)) { wheelNotice(true); return; }
      commitResults(payload,candidate.values,true,'cosmos');
      closeWheelDialog(false);
      openCosmosDialog();
    } catch (failure) {
      if (failure.name !== 'AbortError' && ticket === spinRevision && wheelDialog?.open) wheelNotice();
    }
  }
  async function openWheelCategory(sector) {
    if (!form || !validForm()) return;
    invalidate();
    cancelSpin();
    closeWheelDialog(false);
    const values = formParameters();
    values.set('type',sector.dataset.wheelType);
    values.delete('page');
    // A deliberate category selection uses the normal fresh filter request.
    // Its shared revision/abort guard also prevents a superseded selection
    // from opening the fullscreen view after a newer action has taken over.
    if (await load(values,true,'cosmos')) {
      openCosmosDialog(sector);
    }
  }
  form?.addEventListener('submit', event => {
    event.preventDefault();
    if (discovery) {
      invalidate();
      cancelSpin();
      if (!validForm()) return;
    }
    load(formParameters());
  });
  calendar.addEventListener('click', event => {
    const primaryActivation = event.button === 0 || event.detail === 0;
    if (discovery && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && primaryActivation) {
      const panelToggle = event.target.closest('[data-cosmos-panel-toggle]');
      if (panelToggle) {
        event.preventDefault();
        const panel = panelToggle.dataset.cosmosPanelToggle;
        calendarSetCosmosPanel(cosmosDialog,cosmosDialog?.dataset.mobilePanel === panel ? '' : panel);
        return;
      }
      if (cosmosDialog?.dataset.mobilePanel && cosmosDialog.contains(event.target) && !event.target.closest('.kk-cosmos-sidebar,.kk-discovery-view-panel')) calendarSetCosmosPanel(cosmosDialog);
      if (event.target.closest('[data-wheel-sound]')) {
        event.preventDefault();
        wheelSound.setEnabled(!wheelSound.enabled);
        if (wheelSound.enabled) { wheelSound.prepare(); if (spinning) startWheelTicks(); }
        else stopWheelAudio();
        syncSound(); return;
      }
      if (event.target.closest('button[data-cosmos-motion]')) {
        event.preventDefault();
        if (!reducedMotion.matches) motionWanted=!motionWanted;
        syncMotion(); return;
      }
      const zoomControl=event.target.closest('[data-cosmos-zoom-in],[data-cosmos-zoom-out]');
      if (zoomControl) { event.preventDefault(); cosmosController?.zoom(zoomControl.hasAttribute('data-cosmos-zoom-in') ? 1.2 : 1/1.2); return; }
      const cosmosCategory=event.target.closest('[data-cosmos-category]');
      if (cosmosCategory && form?.elements.namedItem('type')) {
        event.preventDefault();
        if (cosmosCategory.disabled || cosmosCategory.hidden) return;
        calendarSetCosmosPanel(cosmosDialog,'',true);
        invalidate(); cancelSpin();
        form.elements.namedItem('type').value=cosmosCategory.dataset.cosmosCategory;
        load(formParameters(),true,'cosmos');
        return;
      }
      if (event.target.closest('[data-wheel-close]')) { event.preventDefault(); closeWheelDialog(); return; }
      if (event.target.closest('[data-cosmos-close]')) { event.preventDefault(); closeCosmosDialog(); return; }
      if (event.target.closest('[data-wheel-show]')) { event.preventDefault(); showWheelResult(); return; }
      if (event.target.closest('[data-wheel-again]')) { event.preventDefault(); startWheelSpin(spinButton); return; }
      const reset = event.target.closest('[data-calendar-reset]');
      if (reset) {
        event.preventDefault();
        invalidate(); cancelSpin(); restore(new URLSearchParams());
        syncSelected(new URLSearchParams());
        load(new URLSearchParams(), true, 'rail');
        return;
      }
      const remove = event.target.closest('[data-remove-filter]');
      if (remove && form) {
        const name = remove.dataset.removeFilter;
        for (const field of name === 'location' ? ['lat','lng'] : [name === 'q' ? 'calendar_query' : name]) {
          const input = form.elements.namedItem(field);
          if (input) input.value = '';
        }
        form.requestSubmit();
        return;
      }
      const category = event.target.closest('[data-wheel-type]');
      if (category && form?.elements.namedItem('type')) {
        event.preventDefault();
        openWheelCategory(category);
        return;
      }
      const view = event.target.closest('[data-view]');
      if (view) {
        event.preventDefault();
        calendarSetCosmosPanel(cosmosDialog,'',true);
        if (view.dataset.view === 'cosmos') openCosmosDialog(view);
        else { closeCosmosDialog(false); setView('rail'); view.focus({preventScroll:true}); }
        return;
      }
      if (event.target.closest('[data-load-more]')) {
        event.preventDefault();
        railController?.loadMore();
        return;
      }
      const direction = event.target.closest('[data-rail-prev],[data-rail-next]');
      if (direction) {
        event.preventDefault();
        railController?.move(direction.hasAttribute('data-rail-prev') ? -1 : 1);
        return;
      }
      if (event.target.closest('[data-discovery-shuffle]')) {
        calendarSetCosmosPanel(cosmosDialog,'',true);
        invalidate(); cancelSpin();
        if (!validForm()) return;
        const values = formParameters();
        values.set('discovery_seed',calendarNewDiscoverySeed(discoverySeed));
        load(values,true,calendar.dataset.discoveryView).then(success => {
          if (success && label('labelShuffled')) setWheelStatus(label('labelShuffled'));
        });
        return;
      }
      if (event.target.closest('[data-cosmos-reset]')) {
        event.preventDefault();
        calendarSetCosmosPanel(cosmosDialog,'',true);
        cosmosController?.reset();
        return;
      }
    }
    const link = event.target.closest('[data-calendar-results] a');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !primaryActivation) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    // Unfiltered pagination is native Shopify HTML, including its canonical and schema.
    if (!discovery && !hasFilters(parameters(location.search))) return;
    event.preventDefault();
    const values = parameters(url.search);
    if (discovery) {
      invalidate(); cancelSpin();
      // Pagination URLs intentionally omit precise geolocation from the browser
      // address, but the current in-memory filter must continue across pages.
      const current = formParameters();
      for (const name of ['lat','lng','radius']) if (current.has(name)) values.set(name, current.get(name));
    }
    load(values, true, discovery ? calendar.dataset.discoveryView : null).then(success => { if (success) restore(values); });
  });
  window.addEventListener('popstate', () => {
    if (discovery) { closeWheelDialog(false); closeCosmosDialog(false); invalidate(); cancelSpin(); }
    const values = readNavigation();
    restore(values);
    if (discovery) syncSelected(values);
    load(values,false);
  });
  if (discovery && form) {
    calendar.dataset.discoveryEnhanced = 'true';
    calendar.dataset.wheelSpinning = 'false';
    const applyChanges = () => {
      if (composing || !validForm(false)) return;
      load(formParameters());
    };
    form.addEventListener('compositionstart', () => { composing = true; invalidate(); cancelSpin(); });
    form.addEventListener('compositionend', () => { composing = false; clearTimeout(debounce); debounce = setTimeout(applyChanges,400); });
    form.addEventListener('input', event => {
      if (!event.target.matches('input:not([type=hidden])')) return;
      invalidate(); cancelSpin();
      // Text and city entry are debounced; date/month input is committed by change.
      if (!composing && !['date','month'].includes(event.target.type)) debounce = setTimeout(applyChanges,400);
    });
    form.addEventListener('change', event => {
      if (!event.target.matches('select,input[type=date],input[type=month]')) return;
      invalidate(); cancelSpin();
      if (validForm()) applyChanges();
    });
    spinButton?.addEventListener('click', event => { event.stopPropagation(); startWheelSpin(spinButton); });
    wheelDialog?.addEventListener('cancel', event => { event.preventDefault(); closeWheelDialog(); });
    wheelDialog?.addEventListener('close', () => { if (!wheelDialog.open) cleanupWheelDialog(); });
    cosmosDialog?.addEventListener('cancel', event => {
      event.preventDefault();
      if (cosmosDialog.dataset.mobilePanel) calendarSetCosmosPanel(cosmosDialog,'',true);
      else closeCosmosDialog();
    });
    cosmosDialog?.addEventListener('close', () => { if (!cosmosDialog.open) cleanupCosmosDialog(); });
    [wheelDialog,cosmosDialog].filter(Boolean).forEach(dialog => dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom) return;
      if (dialog === wheelDialog) closeWheelDialog(); else closeCosmosDialog();
    }));
    window.addEventListener('pagehide', () => { closeWheelDialog(false); closeCosmosDialog(false); invalidate(); cancelSpin(); });
    document.addEventListener('visibilitychange', () => { syncMotion(); if (document.hidden) { stopWheelAudio(); cosmosController?.stopGesture(); } });
    window.addEventListener('resize', updateRail, {passive:true});
    compactCosmos.addEventListener?.('change', () => {
      calendarSetCosmosPanel(cosmosDialog);
      const hiddenControls = cosmosDialog?.hasAttribute('data-cosmos-compact') || compactCosmos.matches ? '.kk-cosmos-sidebar,.kk-discovery-view-panel' : '.kk-cosmos-mobilebar';
      if (cosmosDialog?.open && document.activeElement?.closest(hiddenControls)) stage()?.focus({preventScroll:true});
    });
    reducedMotion.addEventListener?.('change', () => {
      syncMotion();
      if (reducedMotion.matches && spinning && finishSpin) {
        clearTimeout(spinTimer);
        rotor.style.transition = 'none';
        rotor.style.transform = `rotate(${rotation}deg)`;
        finishSpin();
      }
    });
  }
  restore();
  const initial = readNavigation();
  if (discovery) {
    syncSound();
    syncMotion();
    discoverySeed = initial.get('discovery_seed') || calendarNewDiscoverySeed();
    initial.set('discovery_seed',discoverySeed);
  }
  links(initial);
  if (discovery) {
    syncSelected(initial);
    railController.reset(initial);
    setView(hasFilters(initial) ? 'cosmos' : 'rail',false);
    connectStage();
  }
  const renderedPage = Number(calendar.querySelector('[data-calendar-results]')?.dataset.page || 1);
  if (discovery) {
    // The stored Shopify snapshot is chronological and unfiltered. Fetch the
    // entire catalogue's stable random order once, carrying every URL filter.
    // Replace (rather than push) the initial history entry so reload/back and
    // pagination retain the same order without an extra Back step.
    // Keep any view the visitor opens while this initial request is in flight.
    load(initial,'replace','preserve');
  } else if (hasFilters(initial) || (initial.has('page') && Number(initial.get('page')) !== renderedPage)) load(initial,false);
});
document.querySelectorAll('.kk [data-progress-url]').forEach(panel => {
  let attempts = 0;
  const poll = async () => {
    if (++attempts > 120) return;
    try {
      const response = await fetch(panel.dataset.progressUrl, {headers:{Accept:'application/json'}});
      if (response.ok) {
        const state = await response.json();
        if (['ready','failed','blocked'].includes(state.status)) return location.reload();
      }
    } catch (_) { /* transient network loss is retried */ }
    setTimeout(poll, 5000);
  };
  setTimeout(poll, 3000);
});

document.querySelectorAll('.kk [data-busy-form]').forEach(form => {
  form.addEventListener('submit', event => {
    form.setAttribute('aria-busy', 'true');
    const button = event.submitter;
    if (button?.dataset.busyLabel) button.textContent = '⌛ ' + button.dataset.busyLabel;
  });
});

document.querySelectorAll('.kk [data-hours]').forEach(panel => {
  const rows = [...panel.querySelectorAll('[data-hours-row]')];
  const mode = () => panel.querySelector('[name=hours_mode]:checked')?.value;
  const message = panel.querySelector('[data-hours-message]');
  const range = (row, slot, edge) => row.querySelector(`[data-hours-slot="${slot}"] input[name$="[${edge}]"]`);
  function render() {
    const weekly = mode() === 'weekly';
    panel.querySelector('[data-hours-week]').hidden = !weekly;
    rows.forEach(row => {
      const open = row.querySelector('[data-hours-enabled]').checked;
      row.querySelector('[data-hours-ranges]').hidden = !open;
      row.querySelector('[data-hours-closed]').hidden = open;
      const second = row.dataset.split === 'true' || !!range(row,1,'from').value || !!range(row,1,'to').value;
      row.querySelector('[data-hours-slot="1"]').hidden = !second;
      row.querySelector('[data-hours-split]').hidden = second;
      row.querySelector('[data-hours-remove]').hidden = !second;
      row.querySelectorAll('input[type=time]').forEach(input => {
        input.disabled = !weekly || !open || (input.closest('[data-hours-slot]').dataset.hoursSlot === '1' && !second);
      });
    });
  }
  panel.querySelectorAll('[name=hours_mode],[data-hours-enabled]').forEach(input => input.addEventListener('change',render));
  panel.querySelectorAll('[data-hours-preset]').forEach(button => button.addEventListener('click', () => {
    rows.forEach((row,index) => {
      const open = button.dataset.hoursPreset === 'daily' || (button.dataset.hoursPreset === 'weekdays' ? index < 5 : index > 0);
      row.querySelector('[data-hours-enabled]').checked = open;
      range(row,0,'from').value = open ? '10:00' : '';
      range(row,0,'to').value = open ? '18:00' : '';
      range(row,1,'from').value = ''; range(row,1,'to').value = ''; row.dataset.split = 'false';
    });
    render(); message.textContent = panel.dataset.presetApplied;
  }));
  rows.forEach(row => {
    row.querySelector('[data-hours-split]').addEventListener('click', () => { row.dataset.split='true';render();range(row,1,'from').focus(); });
    row.querySelector('[data-hours-remove]').addEventListener('click', () => { row.dataset.split='false';range(row,1,'from').value='';range(row,1,'to').value='';render(); });
    row.querySelector('[data-hours-copy]').addEventListener('click', () => {
      const fields = [range(row,0,'from'),range(row,0,'to')];
      if (!fields.every(input => input.value && input.reportValidity()) || fields[1].value <= fields[0].value) { fields[0].focus(); return; }
      rows.filter(target => target !== row && target.querySelector('[data-hours-enabled]').checked).forEach(target => {
        for (const slot of [0,1]) for (const edge of ['from','to']) range(target,slot,edge).value=range(row,slot,edge).value;
        target.dataset.split=row.dataset.split || 'false';
      });
      render(); message.textContent=panel.dataset.copied;
    });
  });
  render();
});

;
/* Event sharing follows the Fleury configurator: explicit action, Switchy, direct-link fallback. */
(() => {
  function publicUrl(value, base) {
    try {
      const url = new URL(value, base);
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
      // HTTP is only needed by the isolated local preview.
      if (url.protocol !== 'https:' && !['localhost','127.0.0.1'].includes(url.hostname)) return null;
      return url.href;
    } catch { return null; }
  }
  function destination(action, title, url) {
    const text = `${title}\n${url}`;
    if (action === 'whatsapp') return 'https://wa.me/?text=' + encodeURIComponent(text);
    if (action === 'email') return 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(text);
    return null;
  }
  async function resolveLink(fetcher, endpoint, target, locale, signal) {
    try {
      const address = new URL(endpoint, target);
      if (address.origin !== new URL(target).origin || !/^\/apps\/kunstkalender\/share\/\d+$/.test(address.pathname)) return {url:target, fallback:true};
      const response = await fetcher(address.href, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        credentials:'same-origin', body:JSON.stringify({locale}), signal});
      if (!response.ok) throw new Error('Sharing unavailable');
      const result = await response.json();
      const url = publicUrl(result.url, target);
      if (!result.ok || result.targetUrl !== target || !url) throw new Error('Invalid sharing response');
      return {url, fallback:result.fallback === true};
    } catch (error) {
      if (error.name === 'AbortError' || signal?.aborted) throw error;
      return {url:target, fallback:true};
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {publicUrl, destination, resolveLink};
  if (typeof document === 'undefined') return;
  let count = 0;
  const resolvedLinks = new Map();
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('button[data-event-share]');
    if (!trigger) return;
    event.preventDefault();
    const root = trigger.closest('.kk,[data-event-share-root]');
    const template = root?.querySelector('[data-event-share-template]');
    const target = publicUrl(trigger.dataset.shareUrl, location.href);
    if (!template || !target) return;
    const source = template.content.querySelector('[data-share-dialog]');
    if (!source) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'kk-share-dialog';
    Object.assign(dialog.dataset, source.dataset);
    dialog.append(...source.cloneNode(true).childNodes);
    const heading = dialog.querySelector('[data-share-heading]');
    heading.id = `kk-share-heading-${++count}`;
    dialog.setAttribute('aria-labelledby', heading.id);
    const title = trigger.dataset.shareTitle || '';
    dialog.querySelector('[data-share-event-title]').textContent = title;
    const field = dialog.querySelector('[data-share-url-field]');
    const status = dialog.querySelector('[data-share-status]');
    const actions = Array.from(dialog.querySelectorAll('[data-share-action]'));
    const native = dialog.querySelector('[data-share-action=native]');
    native.hidden = typeof navigator.share !== 'function';
    field.value = resolvedLinks.get(target)?.url || target;
    let controller = null, popup = null, busy = false;
    root.append(dialog);
    const finish = () => {
      controller?.abort();
      if (popup && !popup.closed) popup.close();
      dialog.remove();
      if (trigger.isConnected) trigger.focus({preventScroll:true});
    };
    dialog.addEventListener('close', finish, {once:true});
    dialog.querySelector('[data-share-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', click => {
      if (click.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close();
    });
    field.addEventListener('click', () => field.select());
    async function copy(url) {
      field.value = url;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        return true;
      } catch {
        if (!dialog.open) return false;
        field.focus(); field.select();
        try { return document.execCommand('copy'); } catch { return false; }
      }
    }
    async function performAction(action, result) {
      if (!dialog.open) return;
      field.value = result.url;
      status.textContent = result.fallback ? dialog.dataset.labelFallback : dialog.dataset.labelReady;
      if (action === 'copy') {
        const copied = await copy(result.url);
        if (dialog.open) status.textContent = copied ? dialog.dataset.labelCopied : dialog.dataset.labelManual;
      } else if (action === 'native') {
        try { await navigator.share({title, url:result.url}); }
        catch (failure) { if (dialog.open && failure.name !== 'AbortError') status.textContent = dialog.dataset.labelNativeRetry; }
      } else {
        const href = destination(action, title, result.url);
        if (!href) return;
        if (popup && !popup.closed) {
          try { popup.location.href = href; popup = null; return; }
          catch { popup.close(); popup = null; }
        }
        if (action === 'email') location.href = href;
        else {
          // Popup blocked: a real second-click link retains user activation.
          const link = document.createElement('a');
          link.href = href; link.target = '_blank'; link.rel = 'noopener noreferrer';
          link.className = 'kk-share-continue'; link.textContent = 'WhatsApp ↗';
          status.replaceChildren(link);
        }
      }
    }
    dialog.addEventListener('click', async click => {
      const button = click.target.closest('[data-share-action]');
      if (!button || button.hidden || busy) return;
      const action = button.dataset.shareAction;
      if (!['copy','native','whatsapp','email'].includes(action)) return;
      busy = true;
      actions.forEach(item => { item.disabled = true; });
      status.textContent = dialog.dataset.labelLoading;
      controller = new AbortController();
      let timedOut = false;
      // Reserve the window within the original gesture, before the short-link request.
      if (action === 'whatsapp') {
        try {
          popup = window.open('about:blank', '_blank');
          if (popup) popup.opener = null;
        } catch { popup = null; }
      }
      const timeout = setTimeout(() => { timedOut = true; controller?.abort(); }, 11000);
      try {
        let result = resolvedLinks.get(target);
        if (action === 'native') {
          // The OS sheet needs transient activation from this very click.
          // Use a cached short link when ready, otherwise the canonical event
          // URL immediately; a network await would lose activation on iOS.
          clearTimeout(timeout);
          await performAction(action,result || {url:target,fallback:true});
          return;
        }
        if (!result) {
          // Standalone app pages use the canonical link; Shopify handles proxy signing.
          result = new URL(target).origin === location.origin
            ? await resolveLink(window.fetch.bind(window), trigger.dataset.shareEndpoint, target, trigger.dataset.shareLocale, controller.signal)
            : {url:target, fallback:true};
          resolvedLinks.set(target, result);
        }
        clearTimeout(timeout);
        await performAction(action,result);
      } catch {
        // Closing the dialog cancels sharing. A timeout, however, must still
        // execute the chosen action with the direct link, not just show text.
        if (dialog.open && (timedOut || !controller.signal.aborted)) await performAction(action,{url:target,fallback:true});
        else { if (popup && !popup.closed) popup.close(); popup = null; }
      } finally {
        clearTimeout(timeout);
        busy = false;
        actions.forEach(item => { item.disabled = false; });
      }
    });
    dialog.showModal();
  });
})();

;
/* Private calendar forms stay on their cookie-capable app origin inside the real Shopify page. */
(() => {
  const aliases = {'/submit':'eintragen','/account':'konto','/login':'anmelden','/kunstbrief':'kunstbrief','/portal/continue':'bestaetigen'};
  const allowed = path => /^\/(?:submit(?:\/(?:wizard|progress))?|login(?:\/sent)?|portal\/continue|account(?:\/profiles\/(?:new|[1-9]\d*\/(?:edit|claim))|\/events\/[1-9]\d*\/(?:edit|submitted|delete|preview|images))?|kunstbrief)$/.test(path);
  const confirmation = path => /^\/(?:login|kunstbrief\/confirm)\/[A-Za-z0-9]{64}$/.test(path);
  function safePath(value) {
    if (typeof value !== 'string' || value.length > 300 || !value.startsWith('/') || value.startsWith('//')) return null;
    const url = new URL(value, 'https://calendar.invalid');
    if (url.origin !== 'https://calendar.invalid' || !allowed(url.pathname)) return null;
    const event = url.searchParams.get('event');
    return url.pathname + (url.pathname === '/account/profiles/new' && /^[1-9]\d*$/.test(event || '') ? '?event=' + event : '');
  }
  function fromHash(hash) {
    if (typeof hash !== 'string') return null;
    const value = hash.replace(/^#/, '');
    for (const [path, alias] of Object.entries(aliases)) if (value === alias) return path;
    if (!value.startsWith('verwaltung/')) return null;
    try { return safePath(decodeURIComponent(value.slice('verwaltung'.length))); } catch (_) { return null; }
  }
  function toHash(path) {
    const safe = safePath(path);
    return safe ? '#' + (aliases[safe] || 'verwaltung' + safe) : '';
  }
  const api = {allowed, confirmation, safePath, fromHash, toHash};
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;

  const embedded = document.querySelector('.kk-embedded[data-calendar-app]');
  if (embedded && window.parent !== window) {
    const shop = new URL(embedded.dataset.shopOrigin).origin;
    let lastHeight = 0;
    function report() {
      const raw = location.pathname;
      const path = confirmation(raw) ? '/portal/continue' : safePath(raw + location.search);
      if (!path) return;
      const height = Math.max(400, Math.ceil(embedded.getBoundingClientRect().height));
      if (height === lastHeight) return;
      lastHeight = height;
      window.parent.postMessage({type:'fleury-calendar:view', path, height}, shop);
    }
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin === shop) link.target = '_top';
    });
    new ResizeObserver(report).observe(embedded);
    window.addEventListener('load', report);
    report();
    return;
  }

  const portal = document.querySelector('[data-calendar-portal]');
  if (!portal) return;
  const calendar = document.querySelector('[data-storefront-calendar]');
  const frame = portal.querySelector('[data-portal-frame]');
  const loading = portal.querySelector('[data-portal-loading]');
  const backend = new URL(portal.dataset.backend);
  const home = new URL(portal.dataset.home);
  let current = null;
  function show(path) {
    if (!path) {
      portal.hidden = true;
      if (calendar) calendar.hidden = false;
      if (current) frame.removeAttribute('src');
      current = null;
      return;
    }
    portal.hidden = false;
    if (calendar) calendar.hidden = true;
    if (path === current) return;
    current = path;
    loading.hidden = false;
    const url = new URL(path, backend.origin);
    url.searchParams.set('embedded', '1');
    url.searchParams.set('lang', portal.dataset.locale);
    frame.src = url.href;
  }
  window.addEventListener('message', event => {
    if (event.origin !== backend.origin || event.source !== frame.contentWindow || !current || event.data?.type !== 'fleury-calendar:view') return;
    const path = safePath(event.data.path);
    if (!path || !Number.isFinite(event.data.height)) return;
    frame.style.height = Math.max(400, Math.min(20000, event.data.height)) + 'px';
    loading.hidden = true;
    current = path;
    history.replaceState({}, '', home.pathname + toHash(path));
  });
  window.addEventListener('hashchange', () => show(fromHash(location.hash)));
  function setLanguageReturn(form, language) {
    if (!form || typeof language !== 'string') return;
    const locale = language.toLowerCase().split('-')[0];
    if (!['de','fr','it','en'].includes(locale)) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo || form.querySelector('input[name="form_type"]')?.value !== 'localization') return;
    const alternate = document.querySelector('link[rel="alternate"][hreflang="' + locale + '"]');
    if (!alternate) return;
    let action, target;
    try {
      action = new URL(form.action, home);
      target = new URL(alternate.href, home);
    } catch (_) { return; }
    if (action.origin !== home.origin || !/^\/(?:de\/|fr\/|it\/|en\/)?localization\/?$/.test(action.pathname)) return;
    if (target.origin !== home.origin || target.username || target.password) return;
    if (current) target.search = '';
    target.hash = toHash(current);
    returnTo.value = target.pathname + target.search + target.hash;
  }
  // Update before the header's inline form.submit(), which skips submit events.
  // Shopify still receives the form and saves the language preference.
  window.addEventListener('change', event => {
    if (event.target?.name === 'language_code') setLanguageReturn(event.target.form, event.target.value);
  }, true);
  // Footer language buttons submit their own locale alongside the return path.
  window.addEventListener('submit', event => {
    if (event.submitter?.name === 'language_code') setLanguageReturn(event.target, event.submitter.value);
  }, true);
  portal.querySelector('[data-portal-back]').addEventListener('click', event => {
    event.preventDefault();
    history.pushState({}, '', home.pathname);
    show(null);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    const path = url.origin === backend.origin ? safePath(url.pathname + url.search) : null;
    if (!path) return;
    event.preventDefault();
    if (location.pathname !== home.pathname) { location.assign(home.href + toHash(path)); return; }
    history.pushState({}, '', home.pathname + toHash(path));
    show(path);
    portal.scrollIntoView({block:'start'});
  });
  show(fromHash(location.hash));
})();

;
(() => {
  if (typeof document === 'undefined') return;
  function init(scope = document) {
    scope.querySelectorAll('[data-event-gallery]').forEach(root => {
      if (root.dataset.galleryReady) return;
      const items = [...root.querySelectorAll('[data-gallery-item]')];
      const main = root.querySelector('[data-gallery-main]');
      const opener = root.querySelector('[data-gallery-open]');
      const dialog = root.querySelector('[data-gallery-dialog]');
      const large = root.querySelector('[data-gallery-large]');
      if (!items.length || !main || !opener || !dialog || !large) return;
      const images = items.map(item => ({url:item.getAttribute('href'), alt:item.dataset.galleryAlt || main.alt}));
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const credits = [...root.querySelectorAll('[data-gallery-credit]')];
      const footer = dialog.querySelector('.kk-gallery-footer');
      const close = dialog.querySelector('[data-gallery-close]');
      const ownerDocument = root.ownerDocument;
      let index = 0, trigger, touch;
      const countLabel = () => (root.dataset.galleryCounterLabel || ':current / :total').replace(':current', index + 1).replace(':total', images.length);
      function select(next, focus = false) {
        index = (next % images.length + images.length) % images.length;
        const image = images[index];
        main.src = large.src = image.url;
        main.alt = large.alt = image.alt;
        opener.href = image.url;
        thumbs.forEach((thumb, position) => thumb.setAttribute('aria-current', String(position === index)));
        credits.forEach((credit, position) => { credit.hidden = position !== index; });
        root.querySelectorAll('[data-gallery-counter]').forEach(counter => { counter.textContent = countLabel(); });
        footer.querySelector('[data-gallery-dialog-credit]')?.remove();
        const credit = credits[index]?.querySelector('.kk-image-credit');
        if (credit) {
          const copy = credit.cloneNode(true);
          copy.setAttribute('data-gallery-dialog-credit', '');
          footer.append(copy);
        }
        if (focus && thumbs[index]) {
          thumbs[index].focus({preventScroll:true});
          thumbs[index].scrollIntoView?.({block:'nearest', inline:'nearest', behavior:'instant'});
        }
      }
      thumbs.forEach((thumb, position) => thumb.addEventListener('click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();select(position);
      }));
      opener.addEventListener('click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
        trigger = ownerDocument.activeElement;
        dialog.showModal();event.preventDefault();close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { if (trigger?.isConnected) trigger.focus({preventScroll:true}); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => select(index - 1));
      dialog.querySelector('[data-gallery-next]').addEventListener('click', () => select(index + 1));
      root.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        if (!dialog.open && !thumbs.includes(event.target)) return;
        event.preventDefault();
        select(event.key === 'Home' ? 0 : event.key === 'End' ? images.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1), !dialog.open);
      });
      const viewer = dialog.querySelector('.kk-gallery-viewer');
      viewer.addEventListener('touchstart', event => {
        touch = event.touches.length === 1 ? {x:event.touches[0].clientX, y:event.touches[0].clientY} : null;
      }, {passive:true});
      viewer.addEventListener('touchend', event => {
        if (!touch || !event.changedTouches.length) return;
        const x = event.changedTouches[0].clientX - touch.x, y = event.changedTouches[0].clientY - touch.y;
        touch = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.5) select(index + (x < 0 ? 1 : -1));
      }, {passive:true});
      viewer.addEventListener('touchcancel', () => { touch = null; }, {passive:true});
      root.dataset.galleryReady = 'true';select(0);
    });
  }
  window.KunstkalenderGallery = {init};
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
